export default "__VITE_ASSET__DtLFTf5i__"